import React from 'react';

import { Button, Typo } from '@ers/ui';
import { useDispatch } from 'react-redux';
import { StateManagerProps } from '../Offer';

import { deleteJobOfferLink } from '../offer.actions';

const OfferDeleteForm = ({ prevState, nextState, applicationId }) => {
    const dispatch = useDispatch();
    const confirmClick = () => {
        dispatch(deleteJobOfferLink(applicationId));
        nextState();
    };
    return (
        <div className="offerlink offerlink--center offerlink--column">
            <Typo.Menu className="with-margin--top-6" style={{ textAlign: 'center' }}>Czy na pewno chcesz usunąć link do ogłoszenia?</Typo.Menu>
            <div className="with-margin--top-4 with-margin--bottom-3" style={{ display: 'flex' }}>
                <Button.Tertiary onClick={prevState}>Anuluj</Button.Tertiary>
                <Button.Primary onClick={confirmClick}>Usuń</Button.Primary>
            </div>
        </div>
    );
};
OfferDeleteForm.propTypes = StateManagerProps;

export default OfferDeleteForm;
